<template>
  <div class="flex space-x-4 mt-4">
    <button
      @click="generatePdfClick"
      :disabled="loading"
      class="btn btn-primary flex-1 py-3 transform transition-transform hover:scale-105 active:scale-95">
      <span v-if="!loading">{{ t("ui.download_pdf") }}</span>
      <span v-else>{{ t("ui.generating_pdf") }}</span>
    </button>
    <button @click="$emit('email')" class="btn btn-outline flex-1 py-3 hover:bg-base-100 transition-colors">
      {{ t("ui.send_email") }}
    </button>
  </div>
</template>

<script lang="ts">
import { useI18n } from "vue-i18n";
import { usePdf } from "@/features/blueprint/composables/usePdf";
import { watch } from "vue";
import type { PdfResponseDto } from "@@@/dto/api/PdfResponseDto";

export default {
  setup(_, { emit }) {
    const { t } = useI18n();
    const { generatePdf, result, loading, error } = usePdf();

    // Expose a click handler for the template
    const generatePdfClick = () => {
      generatePdf();
    };

    // When result arrives, trigger download
    watch(result, (pdf: PdfResponseDto | null) => {
      if (!pdf) return;
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${pdf.data}`;
      link.download = pdf.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });

    return {
      t,
      loading,
      error,
      generatePdfClick,
      // if you ever want to inspect result in the template:
      // result,
    };
  },
};
</script>
